import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SuperUserPageSF from '../../../templates/SuperUserPageSF.js'
import CheckBoxUI from '../../../widgets/input/CheckBoxUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import './Triangulation.css'

const TriangulationUI = ({ context, account, accountYearList, financialsFromMCA,
  selectedYear, selectedSection, onShowMonthly, showDetails, showNetProfit, onShowNetProfit,
}) =>
  <div className='c_trng'>
    <TriangulationIncomeUI
      context={context}
      account={account}
      accountYearList={accountYearList} financialsFromMCA={financialsFromMCA} showDetails={showDetails}
      selectedYear={selectedYear} selectedSection={selectedSection} onShowMonthly={onShowMonthly}
    />

    <TriangulationExpenseUI
      context={context}
      account={account}
      accountYearList={accountYearList} financialsFromMCA={financialsFromMCA} showDetails={showDetails}
      selectedYear={selectedYear} selectedSection={selectedSection} onShowMonthly={onShowMonthly}
    />

    <TriangulationCashProfitUI
      context={context}
      account={account}
      accountYearList={accountYearList} financialsFromMCA={financialsFromMCA} showDetails={showDetails}
      selectedYear={selectedYear} selectedSection={selectedSection} onShowMonthly={onShowMonthly}
    />

    <Link className='g_m_left_100' to='#' onClick={onShowNetProfit}>Show triangulation of net cash profit</Link>
    {
      showNetProfit &&
      <TriangulationNetCashProfitUI
        context={context}
        account={account}
        accountYearList={accountYearList} financialsFromMCA={financialsFromMCA} showDetails={showDetails}
        selectedYear={selectedYear} selectedSection={selectedSection} onShowMonthly={onShowMonthly}
      />
    }

  </div>

const TriangulationIncomeUI = ({ context, account, accountYearList, financialsFromMCA, selectedYear, selectedSection, onShowMonthly, showDetails }) =>
  <CardUI title='Triangulation of Income'>
    <table className='tabl'>
      <thead className='g_sticky'>
        <tr>
          <th />
          <th>Financial<br />Year</th>
          <th>Bank<br />Collections</th>
          <th>GST<br />Sales</th>
          <th>MCA/<span className='g_warn'>ITR</span><br />Revenue</th>
          <th>Bank-GST<br />Triangulation</th>
          <th>Bank-MCA/ITR<br />Triangulation</th>
          <th>GST-MCA/ITR<br />Triangulation</th>
          <th>3-Way<br />Triangulation</th>
        </tr>
      </thead>
      <tbody>
        {
          accountYearList.map((accountYear, i) =>
            <TriangulationYearIncomeUI key={i} context={context} account={account} accountYear={accountYear}
              selectedYear={selectedYear} selectedSection={selectedSection} onShowMonthly={onShowMonthly}
              financialsFromMCA={financialsFromMCA}
            />
          )
        }
      </tbody>
    </table>
    {
      showDetails &&
      <div className='g_muted g_m_top_100 g_small'>Bank Revenue = Trade Credits from Bank Analyzer</div>
    }
  </CardUI>

const TriangulationExpenseUI = ({ context, account, accountYearList, financialsFromMCA, selectedYear, selectedSection, onShowMonthly, showDetails }) =>
  <CardUI title='Triangulation of Expense' className='g_m_top_100'>
    <table className='tabl'>
      <thead className='g_sticky'>
        <tr>
          <th />
          <th>Financial<br />Year</th>
          <th>Bank<br />Payments</th>
          <th>GST<br />Purchases</th>
          <th>MCA/<span className='g_warn'>ITR</span><br />Expense</th>
          <th>Bank-GST<br />Triangulation</th>
          <th>Bank-MCA/ITR<br />Triangulation</th>
          <th>GST-MCA/ITR<br />Triangulation</th>
          <th>3-Way<br />Triangulation</th>
        </tr>
      </thead>
      <tbody>
        {
          accountYearList.map((accountYear, i) =>
            <TriangulationYearExpenseUI key={i} context={context} account={account} accountYear={accountYear}
              selectedYear={selectedYear} selectedSection={selectedSection} onShowMonthly={onShowMonthly}
              financialsFromMCA={financialsFromMCA}
            />
          )
        }
      </tbody>
    </table>
    {
      showDetails &&
      <div className='g_muted g_m_top_100 g_small'>Bank Expense = Trade Debits from Bank Analyzer</div>
    }
    {
      showDetails && accountYearList.map((accountYear, i) =>
        <div className='g_muted g_tiny'>
          {accountYear.financialYear}: MCA/ITR Expense: {accountYear.totalPnLPaymentFormula}
        </div>
      )
    }
  </CardUI>

const TriangulationCashProfitUI = ({ context, account, accountYearList, financialsFromMCA, selectedYear, selectedSection, onShowMonthly, showDetails }) =>
  <CardUI title='Triangulation of Cash Profit' className='g_m_top_100 g_m_bottom_100' >
    <table>
      <thead className='g_sticky'>
        <tr>
          <th />
          <th>Financial<br />Year</th>
          <th>Bank<br />Cash Profit</th>
          <th>GST<br />Cash Profit</th>
          <th>MCA/<span className='g_warn'>ITR</span><br />Cash Profit</th>
          <th>Bank-GST<br />Triangulation</th>
          <th>Bank-MCA/ITR<br />Triangulation</th>
          <th>GST-MCA/ITR<br />Triangulation</th>
          <th>3-Way<br />Triangulation</th>
        </tr>
      </thead>
      <tbody>
        {
          accountYearList.map((accountYear, i) =>
            <TriangulationYearCashProfitUI key={i} context={context} account={account} accountYear={accountYear}
              selectedYear={selectedYear} selectedSection={selectedSection} onShowMonthly={onShowMonthly}
              financialsFromMCA={financialsFromMCA}
            />
          )
        }
      </tbody>
    </table>
    {
      showDetails &&
      <>
        <div className='g_muted g_m_top_100 g_small'>Cash profit = Revenue - (Expense + Salary + EMI + Finance cost + Bank charges + Other expenses)</div>
        {
          accountYearList.map((accountYear, i) =>
            <div key={i} className='g_muted g_m_top_50 g_tiny'>
              <table className='table_cp'>
                <tbody>
                  <tr>
                    <td className='year'>{accountYear.financialYear}: </td>
                    <td className='label'>Bank cash profit: </td>
                    <td className='formula'>{accountYear.totalBankProfitLossFormula}</td>
                  </tr>
                  <tr>
                    <td className='year'>{accountYear.financialYear}: </td>
                    <td className='label'>GST cash profit: </td>
                    <td className='formula'>{accountYear.totalGstProfitLossFormula}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )
        }
      </>
    }

  </CardUI>

const TriangulationNetCashProfitUI = ({ context, account, accountYearList, financialsFromMCA, selectedYear, selectedSection, onShowMonthly, showDetails }) =>
  <CardUI title='Triangulation of Net Cash Profit' className='g_m_top_100' >
    <table>
      <thead className='g_sticky'>
        <tr>
          <th />
          <th>Financial<br />Year</th>
          <th>Bank<br />Net Profit</th>
          <th>GST<br />Cash Profit</th>
          <th>MCA/<span className='g_warn'>ITR</span><br />Cash Profit</th>
          <th>Bank-GST<br />Triangulation</th>
          <th>Bank-MCA/ITR<br />Triangulation</th>
          <th>GST-MCA/ITR<br />Triangulation</th>
          <th>3-Way<br />Triangulation</th>
        </tr>
      </thead>
      <tbody>
        {
          accountYearList.map((accountYear, i) =>
            <TriangulationYearNetCashProfitUI key={i} context={context} account={account} accountYear={accountYear}
              selectedYear={selectedYear} selectedSection={selectedSection} onShowMonthly={onShowMonthly}
              financialsFromMCA={financialsFromMCA}
            />
          )
        }
      </tbody>
    </table>
    {
      showDetails &&
      <>
        <div className='g_muted g_m_top_100 g_small'>Cash profit = Revenue - (Expense + Salary + EMI + Finance cost + Bank charges + Other expenses)</div>
        {
          accountYearList.map((accountYear, i) =>
            <div key={i} className='g_muted g_m_top_50 g_tiny'>
              <table className='table_cp'>
                <tbody>
                  <tr>
                    <td className='year'>{accountYear.financialYear}: </td>
                    <td className='label'>Bank cash profit: </td>
                    <td className='formula'>{accountYear.totalBankProfitLossFormula}</td>
                  </tr>
                  <tr>
                    <td className='year'>{accountYear.financialYear}: </td>
                    <td className='label'>GST cash profit: </td>
                    <td className='formula'>{accountYear.totalGstProfitLossFormula}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )
        }
      </>
    }

  </CardUI>

const TriangulationYearIncomeUI = ({ context, account, accountYear, financialsFromMCA, selectedYear, selectedSection, onShowMonthly
}) =>
  <>
    <tr>
      <th>
        <Link to='#' onClick={onShowMonthly} data-year={accountYear.financialYear} data-section='income'>
          {
            /*selectedSection === 'income' && */selectedYear === accountYear.financialYear &&
            <span className="icon icon-angle-down g_xxlarge"></span>
          }
          {
            (/*selectedSection !== 'income' || */selectedYear !== accountYear.financialYear) &&
            <span className="icon icon-angle-right g_xxlarge"></span>
          }
        </Link>
      </th>
      <th className='g_text_right g_no_wrap_2'>{accountYear.financialYear}</th>
      <th className='g_text_right'>{accountYear.totalBankCollectionF4}</th>
      <th className='g_text_right'>{accountYear.totalGstCollectionF4}</th>
      {
        accountYear.financialsFromMCA === false &&
        <th className='g_text_right g_warn'>{accountYear.totalPnLCollectionF4 !== '0' ? accountYear.totalPnLCollectionF4 : ''}</th>
      }
      {
        accountYear.financialsFromMCA === true &&
        <th className='g_text_right'>{accountYear.totalPnLCollectionF4 !== '0' ? accountYear.totalPnLCollectionF4 : ''}</th>
      }
      <RatioTHUI percent={accountYear.bankGstCollectionP} />
      <RatioTHUI percent={accountYear.bankFinancialCollectionP} />
      <RatioTHUI percent={accountYear.gstFinancialCollectionP} />
      <RatioTHUI percent={accountYear.triangulationIncomeP} />
    </tr>
    {
      /*selectedSection === 'income' && */selectedYear === accountYear.financialYear && accountYear.accountMonthList.map((monthlyData, i) =>
      <TriangulationMonthIncomeUI key={i} context={context} account={account} monthlyData={monthlyData} />
    )
    }
  </>

const TriangulationYearExpenseUI = ({ context, account, accountYear, financialsFromMCA, selectedYear, selectedSection, onShowMonthly }) =>
  <>
    <tr>
      <th>
        <Link to='#' onClick={onShowMonthly} data-year={accountYear.financialYear} data-section='expense'>
          {
            /*selectedSection === 'expense' &&*/ selectedYear === accountYear.financialYear &&
            <span className="icon icon-angle-down g_xxlarge"></span>
          }
          {
            (/*selectedSection !== 'expense' ||*/ selectedYear !== accountYear.financialYear) &&
            <span className="icon icon-angle-right g_xxlarge"></span>
          }
        </Link>
      </th>
      <th className='g_text_right g_no_wrap_2'>{accountYear.financialYear}</th>
      <th className='g_text_right'>{accountYear.totalBankPaymentF4}</th>
      <th className='g_text_right'>{accountYear.totalGstPaymentF4}</th>
      {
        accountYear.financialsFromMCA === false &&
        <th className='g_text_right g_warn'>{accountYear.totalPnLPaymentF4 !== '0' ? accountYear.totalPnLPaymentF4 : ''}</th>
      }
      {
        accountYear.financialsFromMCA === true &&
        <th className='g_text_right'>{accountYear.totalPnLPaymentF4 !== '0' ? accountYear.totalPnLPaymentF4 : ''}</th>
      }
      <RatioTHUI percent={accountYear.bankGstPaymentP} />
      <RatioTHUI percent={accountYear.bankFinancialPaymentP} />
      <RatioTHUI percent={accountYear.gstFinancialPaymentP} />
      <RatioTHUI percent={accountYear.triangulationExpenseP} />
    </tr>
    {
      /*selectedSection === 'expense' && */selectedYear === accountYear.financialYear && accountYear.accountMonthList.map((monthlyData, i) =>
      <TriangulationMonthExpenseUI key={i} context={context} account={account} monthlyData={monthlyData} />
    )
    }
  </>

const TriangulationYearCashProfitUI = ({ context, account, accountYear, financialsFromMCA, selectedYear, selectedSection, onShowMonthly
}) =>
  <>
    <tr>
      <th>
        <Link to='#' onClick={onShowMonthly} data-year={accountYear.financialYear} >
          {
            selectedYear === accountYear.financialYear &&
            <span className="icon icon-angle-down g_xxlarge"></span>
          }
          {
            selectedYear !== accountYear.financialYear &&
            <span className="icon icon-angle-right g_xxlarge"></span>
          }
        </Link>
      </th>
      <th className='g_text_right g_no_wrap_2'>{accountYear.financialYear}</th>
      <th className='g_text_right'>{accountYear.totalBankProfitLoss < 0 ? `(${accountYear.totalBankProfitLossF4})` : accountYear.totalBankProfitLossF4}</th>
      <th className='g_text_right'>{accountYear.totalGstProfitLoss < 0 ? `(${accountYear.totalGstProfitLossF4})` : accountYear.totalGstProfitLossF4}</th>
      {
        accountYear.financialsFromMCA === false &&
        <th className='g_text_right g_warn'>
          <span className='g_flex_v'>
            {accountYear.totalPnLProfitLossF4 !== '0' ? (accountYear.totalPnLProfitLoss < 0 ? `(${accountYear.totalPnLProfitLossF4})` : accountYear.totalPnLProfitLossF4) : ''}
            {
              accountYear.totalProfitAfterTax &&
              <span className='g_small g_muted'>Total profit after tax: <br />{accountYear.totalProfitAfterTaxF4}</span>
            }
          </span>
        </th>
      }
      {
        accountYear.financialsFromMCA === true &&
        <th className='g_text_right'>
          <span className='g_flex_v'>
            {accountYear.totalPnLProfitLossF4 !== '0' ? (accountYear.totalPnLProfitLoss < 0 ? `(${accountYear.totalPnLProfitLossF4})` : accountYear.totalPnLProfitLossF4) : ''}
            {
              accountYear.totalProfitAfterTax &&
              <span className='g_small g_muted'>Total profit after tax: <br />{accountYear.totalProfitAfterTaxF4}</span>
            }
          </span>
        </th>
      }
      <RatioTHUI percent={accountYear.bankGstProfitLossP} />
      <RatioTHUI percent={accountYear.bankFinancialProfitLossP} />
      <RatioTHUI percent={accountYear.gstFinancialProfitLossP} />
      <RatioTHUI percent={accountYear.triangulationProfitLossP} />
    </tr>
    {
      selectedYear === accountYear.financialYear && accountYear.accountMonthList.map((monthlyData, i) =>
        <TriangulationMonthCashProfitUI key={i} context={context} account={account} monthlyData={monthlyData} />
      )
    }
  </>

const TriangulationYearNetCashProfitUI = ({ context, account, accountYear, financialsFromMCA, selectedYear, selectedSection, onShowMonthly
}) =>
  <>
    <tr>
      <th>
        <Link to='#' onClick={onShowMonthly} data-year={accountYear.financialYear} >
          {
            selectedYear === accountYear.financialYear &&
            <span className="icon icon-angle-down g_xxlarge"></span>
          }
          {
            selectedYear !== accountYear.financialYear &&
            <span className="icon icon-angle-right g_xxlarge"></span>
          }
        </Link>
      </th>
      <th className='g_text_right g_no_wrap_2'>{accountYear.financialYear}</th>
      <th className='g_text_right'>{accountYear.totalBankProfitLossNet < 0 ? `(${accountYear.totalBankProfitLossNetF4})` : accountYear.totalBankProfitLossNetF4}</th>
      <th className='g_text_right'>{accountYear.totalGstProfitLoss < 0 ? `(${accountYear.totalGstProfitLossF4})` : accountYear.totalGstProfitLossF4}</th>
      {
        accountYear.financialsFromMCA === false &&
        <th className='g_text_right g_warn'>{accountYear.totalPnLProfitLossF4 !== '0' ? (accountYear.totalPnLProfitLoss < 0 ? `(${accountYear.totalPnLProfitLossF4})` : accountYear.totalPnLProfitLossF4) : ''}</th>
      }
      {
        accountYear.financialsFromMCA === true &&
        <th className='g_text_right'>{accountYear.totalPnLProfitLossF4 !== '0' ? (accountYear.totalPnLProfitLoss < 0 ? `(${accountYear.totalPnLProfitLossF4})` : accountYear.totalPnLProfitLossF4) : ''}</th>
      }
      <RatioTHUI percent={accountYear.bankGstProfitLossP} />
      <RatioTHUI percent={accountYear.bankFinancialProfitLossP} />
      <RatioTHUI percent={accountYear.gstFinancialProfitLossP} />
      <RatioTHUI percent={accountYear.triangulationProfitLossP} />
    </tr>
    {
      selectedYear === accountYear.financialYear && accountYear.accountMonthList.map((monthlyData, i) =>
        <TriangulationMonthNetCashProfitUI key={i} context={context} account={account} monthlyData={monthlyData} />
      )
    }
  </>

const TriangulationMonthIncomeUI = ({ context, account, monthlyData }) =>
  <tr>
    <td></td>
    <td className='g_text_right g_no_wrap_2'>{monthlyData.yearMonth}</td>
    <td className='g_text_right'>
      <Link to={`/su/accounts/${account.accountId}/clientTxnCashTransactions/trade_credits/${monthlyData.year}/${monthlyData.month}`}>
        {monthlyData.bankCollectionF4}
      </Link>
    </td>
    <td className='g_text_right'>{monthlyData.gstCollectionF4}</td>
    <td />
    <RatioTDUI percent={monthlyData.collectionRatioP} />
    <RatioTDUI percent={monthlyData.bankFinancialCollection} />
    <RatioTDUI percent={monthlyData.gstFinancialCollection} />
  </tr>

const TriangulationMonthExpenseUI = ({ context, account, monthlyData
}) =>
  <tr>
    <td></td>
    <td className='g_text_right g_no_wrap_2'>{monthlyData.yearMonth}</td>
    <td className='g_text_right'>
      <Link to={`/su/accounts/${account.accountId}/clientTxnCashTransactions/trade_debits/${monthlyData.year}/${monthlyData.month}`}>
        {monthlyData.bankPaymentF4}
      </Link>
    </td>
    <td className='g_text_right'>{monthlyData.gstPaymentF4}</td>
    <td />
    <RatioTDUI percent={monthlyData.paymentRatioP} />
    <RatioTDUI percent={monthlyData.bankFinancialPayment} />
    <RatioTDUI percent={monthlyData.gstFinancialPayment} />
  </tr>

const TriangulationMonthCashProfitUI = ({ context, account, monthlyData }) =>
  <tr>
    <td></td>
    <td className='g_text_right g_no_wrap_2'>{monthlyData.yearMonth}</td>
    <td className='g_text_right'>
      <Link to={`/su/accounts/${account.accountId}/clientTxnCashTransactions/trade_credits/${monthlyData.year}/${monthlyData.month}`}>
        {monthlyData.bankProfitLoss < 0 ? `(${monthlyData.bankProfitLossF4})` : monthlyData.bankProfitLossF4}
      </Link>
    </td>
    <td className='g_text_right'>{monthlyData.gstProfitLoss < 0 ? `(${monthlyData.gstProfitLossF4})` : monthlyData.gstProfitLossF4}</td>
    <td />
    <RatioTDUI percent={monthlyData.profitLossRatioP} />
    <RatioTDUI percent={monthlyData.bankFinancialCollection} />
    <RatioTDUI percent={monthlyData.gstFinancialCollection} />
  </tr>

const TriangulationMonthNetCashProfitUI = ({ context, account, monthlyData }) =>
  <tr>
    <td></td>
    <td className='g_text_right g_no_wrap_2'>{monthlyData.yearMonth}</td>
    <td className='g_text_right'>
      <Link to={`/su/accounts/${account.accountId}/clientTxnCashTransactions/trade_credits/${monthlyData.year}/${monthlyData.month}`}>
        {monthlyData.bankProfitLossNet < 0 ? `(${monthlyData.bankProfitLossNetF4})` : monthlyData.bankProfitLossNetF4}
      </Link>
    </td>
    <td className='g_text_right'>{monthlyData.gstProfitLoss < 0 ? `(${monthlyData.gstProfitLossF4})` : monthlyData.gstProfitLossF4}</td>
    <td />
    <RatioTDUI percent={monthlyData.profitLossRatioP} />
    <RatioTDUI percent={monthlyData.bankFinancialCollection} />
    <RatioTDUI percent={monthlyData.gstFinancialCollection} />
  </tr>

const RatioTHUI = ({ percent }) =>
  <th className={`g_text_right ${percent ?
    (percent >= 0 && (percent < 80 || percent > 125) || percent < 0 && (percent > -80 || percent < -125) ? 'g_error' : 'g_success') :
    'g_error'}`}>
    {
      (percent > 9900 || percent < -9900) &&
      <span className='g_xxlarge'>∞</span>
    }
    {
      percent && percent <= 9900 && percent >= -9900 && percent !== '0.00' &&
      <span>{percent}%</span>
    }
    {
      (!percent || percent === '0.00') &&
      <span>-</span>
    }
  </th>

const RatioTDUI = ({ percent }) =>
  <td className={`g_text_right ${percent ?
    (percent >= 0 && (percent < 80 || percent > 125) || percent < 0 && (percent > -80 || percent < -125) ? 'g_error' : 'g_success') :
    ''}`}>
    {
      (percent > 9900 || percent < -9900) &&
      <span className='g_xxlarge'>∞</span>
    }
    {
      percent && percent <= 9900 && percent >= -9900 &&
      <span>{percent}%</span>
    }
    {
      !percent &&
      <span>-</span>
    }
  </td>

export default TriangulationUI
